import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, FormFeedback, Alert } from 'reactstrap';
import { FaPlusCircle } from 'react-icons/fa';
import FaTrash from "../../imgs/deleteIcon.png"
import FaPencilAlt from "../../imgs/lapiz.svg"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

class TablaServiciosH extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],
            listaAux: [],

            modalIDServicioHijo: "",
            modalNombreServicio: "",
            modalIDPadre: "",
            invalid2: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalNuevo = this.modalNuevo.bind(this);
        this.modalEditar = this.modalEditar.bind(this);
        this.modalEliminar = this.modalEliminar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.borrarSeleccion = this.borrarSeleccion.bind(this);
        this.editarSeleccion = this.editarSeleccion.bind(this);
        this.agregarDato = this.agregarDato.bind(this);
        this.handleChangeModalAgregar = this.handleChangeModalAgregar.bind(this);
        this.handleChangeModalEditar = this.handleChangeModalEditar.bind(this);
        this.handleSelectAux = this.handleSelectAux.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleSelectAux(e) {
        await this.setState({
            modalIDPadre: e.target.selectedOptions[0].value
        })
    }

    async handleChangeModalAgregar(e) {
        var opcionesAux = this.state.listaAux.map(p => {
            return (<option key={p.seqServicio} value={p.seqServicio} id={p.namServicio} name={p.namServicio}>{p.namServicio} </option>)
        });
        const idVariable = e.target.name;
        switch (idVariable) {
            case "modalNombreServicio":
                if (e.target.value.length <= 80) { //PASO 31 A 80
                    await this.setState({
                        modalNombreServicio: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Servicio</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalAgregar} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Servicio Padre</Label>
                                            <Input defaultValue={this.state.modalIDPadre} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                                {opcionesAux}
                                            </Input>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async handleChangeModalEditar(e) {
        const idVariable = e.target.name;
        switch (idVariable) {
            case "modalNombreServicio":
                if (e.target.value.length <= 80) { // PASO 31 A 80
                    await this.setState({
                        modalNombreServicio: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 12 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Servicio</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalEditar} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando los servicios existentes, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/serviciosHijo");
            //const response = { DataJson }
            await this.setState({
                datosTraidos: response.data
                //datosTraidos: response.DataJson
            })

            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/serviciosPadre");
            await this.setState({
                listaAux: response2.data
            })

            if (bool === true) {
                this.toggle();
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }
    }

    async modalNuevo() {
        var opcionesAux = this.state.listaAux.map(p => {
            return (<option key={p.seqServicio} value={p.seqServicio} id={p.namServicio} name={p.namServicio}>{p.namServicio} </option>)
        });
        await this.setState({
            auxID: 999,
            invalid2: false,
            modalIDServicioHijo: "",
            modalNombreServicio: "",
            modalIDPadre: 1,
        })

        this.setState({
            invalid2: false,
            modalIDServicioHijo: "",
            modalNombreServicio: "",
            modalIDPadre: this.state.listaAux[0].seqServicio,
            modalTitulo: "Agregar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Servicio</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalAgregar} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Servicio padre</Label>
                                <Input defaultValue={this.state.listaAux[0].seqServicio} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                    {opcionesAux}
                                </Input>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.agregarDato} color="success">Agregar</Button>
            </div>
        })
        this.toggle();
    }
    async agregarDato() {
        var hayError = false;
        if (this.state.modalNombreServicio === undefined || this.state.modalNombreServicio === "" || this.state.modalNombreServicio === null || this.state.modalNombreServicio.length < 2 || this.state.modalNombreServicio.length >= 81) { // PASO 21 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (hayError === true) {
            var opcionesAux = this.state.listaAux.map(p => {
                return (<option key={p.seqServicio} value={p.seqServicio} id={p.namServicio} name={p.namServicio}>{p.namServicio} </option>)
            });
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre servicio</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalAgregar} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Servicio padre</Label>
                                            <Input defaultValue={this.state.modalIDPadre} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                                {opcionesAux}
                                            </Input>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            var mapAux = {};
            if (this.state.listaAux.length > 0) {
                for (var i = 0; i < this.state.listaAux.length; i++) {
                    mapAux[this.state.listaAux[i].seqServicio] = this.state.listaAux[i].tipoServicio;
                }
            }
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                seqServicio: null,
                servicioAntecesor: this.state.modalIDPadre,
                namServicio: this.state.modalNombreServicio,
                tipoServicio: mapAux[this.state.modalIDPadre],
                esFinal: 1,
            }
            try {
                const response = await axios.post(OBTENER_URL_SERVICIO + "/servicio/new", envioDatos);
                if (response.data.tipo === "EXITO") {
                    this.setState({
                        modalTitulo: "Exito",
                        modalMensaje:
                            <div>
                                <p>¡Dato agregado!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "ERROR") {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                const response2 = await axios.get(OBTENER_URL_SERVICIO + "/serviciosPadre");
                await this.setState({
                    listaAux: response2.data
                })
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    async modalEditar(event) {
        const datos = event.target.id;
        const arrayDatos = datos.split("///");
        await this.setState({
            auxID: arrayDatos[0],
            modalIDServicioHijo: arrayDatos[0],
            modalNombreServicio: arrayDatos[1],
            modalIDPadre: arrayDatos[2]
        })
        this.setState({
            invalid2: false,
            modalTitulo: "Editar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 12 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Servicio</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalEditar} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.editarSeleccion} color="warning">Editar</Button>
            </div>
        })
        this.toggle();
    }
    async editarSeleccion() {
        var hayError = false;
        if (this.state.modalNombreServicio === undefined || this.state.modalNombreServicio === "" || this.state.modalNombreServicio === null || this.state.modalNombreServicio.length < 1 || this.state.modalNombreServicio.length >= 81) { // PASO 33 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (hayError === true) {
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Servicio</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreServicio} bsSize="sm" type="text" name="modalNombreServicio" id="modalNombreServicio" onChange={this.handleChangeModalEditar} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                seqServicio: this.state.modalIDServicioHijo,
                servicioAntecesor: null,
                namServicio: this.state.modalNombreServicio,
                tipoServicio: this.state.modalIDPadre,
                esFinal: 1,
            }
            try {
                const response = await axios.put(OBTENER_URL_SERVICIO + "/servicio/" + this.state.auxID, envioDatos);
                if (response.data.tipo === "Actualizado") {
                    this.setState({
                        modalTitulo: "Actualizado",
                        modalMensaje:
                            <div>
                                <p>¡Dato actualizado con éxito!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "Error") {
                        this.setState({
                            modalTitulo: "Dato no encontrado",
                            modalMensaje:
                                <div>
                                    <p>No se encontró el dato para eliminar.</p>
                                    <p>{response.data.mensaje}</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    modalEliminar(event) {
        this.setState({
            modalTitulo: "Eliminar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>¡ATENCIÓN!</Label>
                            <br />
                            <Label>Se eliminará el dato seleccionado.</Label>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} onClick={this.borrarSeleccion} color="danger">Eliminar</Button>
            </div>
        })
        this.toggle();
    }
    async borrarSeleccion(event) {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        try {
            const response = await axios.delete(OBTENER_URL_SERVICIO + "/servicio/" + event.target.id);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "EXITO",
                    modalMensaje:
                        <div>
                            <p>¡Dato eliminado con éxito!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "NO ENCONTRADO") {
                    this.setState({
                        modalTitulo: "Dato no encontrado",
                        modalMensaje:
                            <div>
                                <p>No se encontró el dato para eliminar.</p>
                                <p>{response.data.mensaje}</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>{response.data.mensaje}</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }

    }

    render() {

        var datosTabla =
            <Alert color="primary">
                No hay servicios Hijo asociados con Padre
        </Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            var mapAux = {};
            if (this.state.listaAux.length > 0) {
                for (var i = 0; i < this.state.listaAux.length; i++) {
                    mapAux[this.state.listaAux[i].seqServicio] = this.state.listaAux[i].namServicio;
                }
            }
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID servicio</th>
                            <th>Nombre servicio</th>
                            <th>Servicio padre</th>
                            <th>Tipo de servicio</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            if (p.tipoServicio === 1) {
                                return (
                                    <tr key={p.seqServicio}>
                                        <th scope="row">{p.seqServicio}</th>
                                        <td>{p.namServicio}</td>
                                        <td>{mapAux[p.servicioAntecesor]}</td>
                                        <td>General</td>
                                        <td><Button size="sm" color="warning" id={p.seqServicio + "///" + p.namServicio + "///" + 1} onClick={this.modalEditar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p.seqServicio + "///" + p.namServicio + "///" + 1} alt="editar" /></Button>{" | | "}<Button size="sm" color="danger" id={p.seqServicio} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p.seqServicio} alt="borrar" /></Button></td>
                                    </tr>
                                )
                            } else {
                                return (
                                    <tr key={p.seqServicio}>
                                        <th scope="row">{p.seqServicio}</th>
                                        <td>{p.namServicio}</td>
                                        <td>{mapAux[p.servicioAntecesor]}</td>
                                        <td>Específico</td>
                                        <td><Button size="sm" color="warning" id={p.seqServicio + "///" + p.namServicio + "///" + 2} onClick={this.modalEditar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p.seqServicio + "///" + p.namServicio + "///" + 2} alt="editar" /></Button>{" | | "}<Button size="sm" color="danger" id={p.seqServicio} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p.seqServicio} alt="borrar" /></Button></td>
                                    </tr>
                                )
                            }

                        })}
                    </tbody>
                </Table>
        }
        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Servicios Hijo </Label> <Button className="btn btn-success float-right" onClick={this.modalNuevo}><FaPlusCircle></FaPlusCircle> Agregar Servicios Hijo</Button></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TablaServiciosH;